import './css/CustomerDetail.css'

import { Fragment, useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Button, Space, Row } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'

import AddHospitalEscort from './components/AddHospitalEscort'
import AddNursing from './components/AddHomeNursing'
import UpdateHospitalEscort from './components/UpdateHospitalEscort'
import UpdateNursing from './components/UpdateNursing'
import DownHospitalEscort from './components/OperateDownHospitalEscort'
import OperateChangeNursing from './components/OperateChangeNursing'
import OperateOrderUp from './components/OperateNursingOrderUp'
import OperateOrderAdvance from './components/OperateNursingOrderAdvance'
import OperateOrderDown from './components/OperateNursingOrderDown'

import CustomerInfo from './components/HomeCustomerInfo'
import CustomerServiceInfo from './components/HomeCustomerServiceInfo'

import RecordDealInfo from './components/RecordDealInfo'
import RecordNursingWork from './components/RecordNursingWork'
import RecordNursingWorkDetail from './components/RecordNursingWorkDetail'

interface client {
    id: string // 客户标识
    deal_id: string // 签单标识
    deal_date: string // 签单日期
    deal_store_name: string // 签单门店
    deal_item_name: string // 签单套餐名称
    nursing_care_type_desc: string // 护理模式
    hospital_escort_days: number // 医院陪护天数
    customer_name: string // 姓名
    customer_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期
    service_status: number  // 服务状态，0待分配 1待上户 2已上单 3已下单
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
    service_left_days: number // 剩余天数
    service_address: string // 服务地址
}

interface serviceRecord {
    work_id: string, // 上单标识
    nursing_care_type: number // 护理模式
    nursing_care_type_desc: string // 护理模式描述
    belong_nursing_name: string  // 护理师
    service_status: number // 服务状态
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
}

export default function () {

    const [tabCurrent, setTabCurrent] = useState<number>(0)
    const [clientData, setClientData] = useState<client>()
    const [serviceRecordData, setServiceRecordData] = useState<serviceRecord[]>([])
    const [reservedService, setReservedService] = useState<serviceRecord>()

    const [inService, setInService] = useState<serviceRecord>()
    const [inHospitalService, setInHospitalService] = useState<serviceRecord>()

    const param: { id: string } = useParams()
    const [statusStr, setStatusStr] = useState<string>('')

    const history = useHistory()

    useEffect(() => {
        getClientInfo()
    }, [])

    // 查询客户信息
    const getClientInfo = () => {
        baseAxiosNoInfo('/yuesao_center/customer/residence/detail', {
            params: {
                customer_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setClientData(res)

                switch (res.service_status) {
                    case 1:
                        setStatusStr('待上户')
                        break
                    case 2:
                        setStatusStr('已上单')
                        break
                    case 3:
                        setStatusStr('已下单')
                        break
                    default:
                        setStatusStr('待分配')
                        break
                }

                baseAxiosNoInfo('/yuesao_center/customer/detail/nursing_work_records', {
                    params: {
                        deal_id: res.deal_id
                    }
                }).then((res: any) => {
                    if (res) {
                        setServiceRecordData(res)

                        res.map((el: any) => (
                            (el.nursing_care_type === 5 && el.service_status === 1) &&
                            setReservedService(el)
                            ||
                            (el.nursing_care_type === 5 && el.service_status === 2) &&
                            setInService(el)
                        ))

                        const inServiceRecord = findRecordByStatus(res, 4, 2)

                        if (inServiceRecord) {
                            setInHospitalService(inServiceRecord)

                        } else if (isAllStatusByCareType(res, 4, 3)) {
                            const latestRecord = getLatestRecordByCareType(res, 4)

                            if (latestRecord) {
                                setInHospitalService(latestRecord)
                            }
                        }
                    }
                })
            }
        })
    }

    // 查找护理类型的第一条记录
    const findRecordByStatus = (
        list: any[],
        careType: number,
        serviceStatus: number
    ): any | undefined => {
        return list.find(el =>
            el.nursing_care_type === careType && el.service_status === serviceStatus
        )
    }

    // 判断护理类型的状态
    const isAllStatusByCareType = (
        list: any[],
        careType: number,
        serviceStatus: number
    ): boolean => {
        const filtered = list.filter(el => el.nursing_care_type === careType)
        return filtered.length > 0 && filtered.every(el => el.service_status === serviceStatus)
    }

    // 获取护理类型的最新记录
    const getLatestRecordByCareType = (
        list: any[],
        careType: number,
        timeField: string = 'create_time'
    ): any | undefined => {
        const filtered = list.filter(el => el.nursing_care_type === careType)
        if (filtered.length === 0) return undefined

        return [...filtered].sort((a, b) =>
            new Date(b[timeField]).getTime() - new Date(a[timeField]).getTime()
        )[0]
    }

    return <div className="common-level2-edit h-detail">
        {/* 月嫂中心 -> 客户管理 -> 到府客户管理 -> 客户详情 */}
        <p className="modules-h2">客户详情</p>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => {
                history.replace({
                    pathname: '/yuesao_residence_manage',
                    state: history.location.state
                })
            }} >返回</Button>
        </div>

        {/* 医院陪护 */}
        {clientData?.hospital_escort_days !== 0 && inHospitalService == null && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 分配医院陪护 */}
                <AddHospitalEscort clientData={clientData} onChange={() => {
                    getClientInfo()
                }} />
            </Row>
        </Space>}

        {/* 医院陪护 */}
        {inHospitalService?.service_status == 2 && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 更换医院陪护 */}
                <UpdateHospitalEscort serviceRecord={inHospitalService} onChange={() => {
                    getClientInfo()
                }} />

                {/* 下单医院陪护 */}
                <DownHospitalEscort serviceRecord={inHospitalService} onChange={() => {
                    getClientInfo()
                }} />
            </Row>
        </Space>}

        {/* 待分配 */}
        {(clientData?.service_status === 0) && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 分配护理师 */}
                <AddNursing clientData={clientData} onChange={() => {
                    getClientInfo()
                }} />
            </Row>
        </Space>}

        {/* 待上户 */}
        {(clientData?.service_status === 1) && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 调整护理师 */}
                <OperateChangeNursing serviceRecord={reservedService} onChange={() => {
                    getClientInfo()
                }} />

                {/* 办理上单 */}
                <OperateOrderUp serviceRecord={reservedService} onChange={() => {
                    getClientInfo()
                }} />
            </Row>
        </Space>}

        {/* 已上单 */}
        {(clientData?.service_status === 2) && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 更换护理师 */}
                <UpdateNursing serviceRecord={inService} onChange={() => {
                    getClientInfo()
                }} />

                {/* 提前下单 */}
                <OperateOrderAdvance serviceRecord={inService} onChange={() => {
                    getClientInfo()
                }} />

                {/* 办理下单 */}
                <OperateOrderDown serviceRecord={inService} onChange={() => {
                    getClientInfo()
                }} />
            </Row>
        </Space>}

        {/* 客户信息 */}
        <CustomerInfo status={statusStr} data={clientData} onChange={() => {
            getClientInfo()
        }} />

        {/* 服务信息 */}
        {
            clientData?.service_status !== 0 && <CustomerServiceInfo data={serviceRecordData} onFetched={() => {
                getClientInfo()
            }} />
        }

        <Space direction="horizontal" wrap className="tab clear" style={{ width: '95%' }}>
            <div className={tabCurrent === 0 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(0) }}>签单记录</div>
            <div className={tabCurrent === 1 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(1) }}>服务记录</div>

            {(clientData?.service_status === 2 || clientData?.service_status === 3) && <Fragment>
                <div className={tabCurrent === 2 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(2) }}>服务操作记录</div>
            </Fragment>}
        </Space>

        <div className="tab-cont">
            {tabCurrent === 0 ? <div className="cont">
                <RecordDealInfo data={clientData} />
            </div> : null}
            {tabCurrent === 1 ? <div className="cont">
                <RecordNursingWork dealID={clientData?.deal_id} />
            </div> : null}

            {(clientData?.service_status === 2 || clientData?.service_status === 3) && <Fragment>
                {tabCurrent === 2 ? <div className="cont">
                    <RecordNursingWorkDetail dealID={clientData?.deal_id} />
                </div> : null}
            </Fragment>}
        </div>
    </div >
}